<p class="mt-2 mb-4 mr-4 ml-4">{{ 'popins.order_message.message' | translate }}</p>
<div class="header-actions">
    <button class="close" (click)="close()" title="{{ 'generic.close' | translate }}">
        <span class="icon-view-close" aria-hidden="true">
            <svg>
                <use xlink:href="assets/img/icons.svg#icon-view-close"></use>
            </svg>
        </span>
        <span>{{ 'generic.close' | translate }}</span>
    </button>
</div>
<div class="text-center">
    <ng-hbm-bdi-btn class="primary" (click)="continue()" [loading]="orderProcessing" [label]="'popins.order_message.continue' | translate"></ng-hbm-bdi-btn>
    <ng-hbm-bdi-btn class="light-grey mr-3 ml-3" (click)="contact()" [label]="'popins.order_message.contact' | translate"></ng-hbm-bdi-btn>
</div>